import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Components from "@/pages/Components";
import SubAssemblies from "@/pages/SubAssemblies";
import Assemblies from "@/pages/Assemblies";
import Inventory from "@/pages/Inventory";
import Reports from "@/pages/Reports";
import CashAdvances from "@/pages/CashAdvances";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/components" element={<Components />} />
              <Route path="/sub-assemblies" element={<SubAssemblies />} />
              <Route path="/assemblies" element={<Assemblies />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/cash-advances" element={<CashAdvances />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requiredRoles={["super_admin", "project_admin"]} />
                }
              >
                <Route index element={<Admin />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
